export const RA_STEPS_IDENTIFIERS = {
  RETIREMENT_DATE_AND_GUIDANCE: "RETIREMENT_DATE_AND_GUIDANCE",
  OTHER_PENSIONS: "OTHER_PENSIONS",
  CHOOSING_YOUR_RETIREMENT: "CHOOSING_YOUR_RETIREMENT",
  BANK_MANDATE: "BANK_MANDATE",
  RA_IDENTITY_AND_VERIFICATION: "RA_IDENTITY_AND_VERIFICATION",
  DECLARATION: "DECLARATION",

  RA_APPLICATION_WAKE_UP_INFO: "RA_APPLICATION_WAKE_UP_INFO",
  RA_APPLICATION_DATE: "RA_APPLICATION_DATE",
  RA_PENSION_WISE: "RA_GUIDE_AND_ADVICE",

  RA_OTHER_PENSIONS: "RA_OTHER_PENSIONS",
  RA_LUMP_SUM_ALLOWANCES: "RA_LUMPSUM",
  RA_OFFLINE_PENSION: "RA_OFFLINE_PENSION",

  RA_POT_SELECTION: "RA_POT_SELECTION",
  RA_RETIREMENT_CHOICE: "RA_RETIREMENT_CHOICE",
  BANK_MANDATE_CONFIRM: "BANK_MANDATE_CONFIRM",
  RA_DECLARATION_CONFIRM: "RA_DECLARATION_CONFIRM",
  RA_ILLUSTRATION: "RA_ILLUSTRATION",
  RA_CONFIRM_DETAILS: "RA_CONFIRM_DETAILS",
  RA_CONFIRM_CHOICE: "RA_CONFIRM_CHOICE",
  RA_TAKE_MONEY_IN_CHUNKS: "RA_TAKE_MONEY_IN_CHUNKS",
  RA_TAKE_ALL_IN_ONE_GO: "RA_TAKE_ALL_IN_ONE_GO",
  RA_CONTRIBUTION: "RA_CONTRIBUTION",
  RA_TAX_FREE_CASH: "RA_TAX_FREE_CASH",
  RA_ANNUITY_CHOICE: "RA_ANNUITY_CHOICE",
  RA_ANNUITY_PROVIDER: "RA_ANNUITY_PROVIDER",
  RA_RI_CASH_LUMPSUM: "RA_RI_CASH_LUMPSUM",
  RA_RI_INVEST_THE_REST: "RA_RI_INVEST_THE_REST",
  RA_MM_CASH_LUMPSUM: "RA_MM_CASH_LUMPSUM",
  RA_BEND_STRATEGIES: "RA_BEND_STRATEGIES",

  RA_INVEST_THE_REST: "RA_INVEST_THE_REST",
  RA_APPLICATION_SUCCESS: "RA_APPLICATION_SUCCESS",
};
export const initialRaSteps = [
  {
    title: "Guidance and advice",
    identifier: "RETIREMENT_DATE_AND_GUIDANCE",
    description:
      "We ask whether you have received financial guidance or advice about this application.",
    guideAndAdvanceTitle: "Guidance and advice",
    guideAndAdvance:
      "We ask whether you have received financial guidance or advice about this application.",
    isBegin: true,
    isComplete: false,
    isUpComing: false,
    isSubStepsOpen: false,
    sequence: 1,
    timer: "2 MINS",
    subSteps: [
      {
        name: "Pension Wise",
        identifier: "PENSION_WISE",
        isSubBegin: true,
        isSubComplete: false,
        sequence: 11,
        isSubUpComing: false,
      },
    ],
    infoDocSection: {
      infoOrDoc: "",
      infoDocList: [],
    },
  },
  {
    title: "Other pensions",
    identifier: "OTHER_PENSIONS",
    description:
      "We need to ensure that your pension payment is within the tax allowances set by HM Revenue & Customs (HMRC).",
    isBegin: false,
    isComplete: false,
    isUpComing: true,
    isSubStepsOpen: false,
    sequence: 2,
    timer: "2 MINS",
    subSteps: [
      {
        name: "Lump sum allowances",
        identifier: "LUMP_SUM_ALLOWANCES",
        isSubBegin: true,
        isSubComplete: false,
        isSubUpComing: false,
        sequence: 21,
      },
    ],
    // infoDocSection: {
    //   infoOrDoc: "Information required",
    //   infoDocList: [
    //     {
    //       name: "Details of significant previous and current lump sums from UK pensions and/or tax allowance protections.",
    //     },
    //   ],
    // },
  },
  {
    title: "Choosing your retirement",
    identifier: "CHOOSING_YOUR_RETIREMENT",
    description:
      "You can take some or all of your pension pot(s). Then you can choose from several different ways to use your pension savings, including to mix and match more than one option.",
    isBegin: false,
    isComplete: false,
    isUpComing: true,
    isSubStepsOpen: false,
    timer: "6 MINS",
    sequence: 3,
    subSteps: [
      {
        name: "Pot selection",
        identifier: "RA_POT_SELECTION",
        isSubBegin: true,
        isSubComplete: false,
        isSubUpComing: false,
        sequence: 31,
      },
      {
        name: "Retirement choice",
        identifier: "RA_RETIREMENT_CHOICE",
        isSubBegin: false,
        isSubComplete: false,
        isSubUpComing: true,
        sequence: 32,
      },
    ],
    infoDocSection: {
      infoOrDoc: "Things to consider",
      infoDocList: [
        {
          name: "If you choose a guaranteed income (annuity), we’ll need the name of your chosen annuity provider (and remember to upload payment instructions from your provider).",
        },
        {
          name: "Please ensure that you review the illustration provided during your application.",
        },
        {
          name: "Read the ‘what to expect’ information where you began this application.",
        },
      ],
    },
  },
  {
    title: "Bank mandate",
    identifier: "BANK_MANDATE",
    description:
      "Please provide your bank details so we can pay you. \n\nFor your security, we will not store your bank details until you submit your application. If you navigate away from this application, you will need to resubmit these details.",
    isBegin: false,
    isComplete: false,
    isUpComing: true,
    isSubStepsOpen: false,
    sequence: 4,
    timer: "2 MINS",
    subSteps: [
      {
        name: "Bank details",
        identifier: "BANK_DETAILS",
        isSubBegin: true,
        isSubComplete: false,
        isSubUpComing: false,
        sequence: 41,
      },
      {
        name: "Confirm details",
        identifier: "CONFIRM_DETAILS",
        isSubBegin: false,
        isSubComplete: false,
        isSubUpComing: true,
        sequence: 42,
      },
    ],
    infoDocSection: {
      infoOrDoc: "Information required",
      infoDocList: [
        {
          name: "Bank account in your name (or named on a joint account)",
        },
      ],
    },
  },
  {
    title: "Identification and verification",
    identifier: "RA_IDENTITY_AND_VERIFICATION",
    description:
      "We will verify your identity and bank details before we make your payment. This will be handled through a secure third-party process.",
    isBegin: false,
    isComplete: false,
    isUpComing: true,
    isSubStepsOpen: false,
    sequence: 5,
    timer: "4 MINS",
    subSteps: [
      {
        name: "Identity and verification",
        identifier: "RA_IDENTITY_AND_VERIFICATION",
        isSubBegin: true,
        isSubComplete: false,
        isSubUpComing: false,
        sequence: 51,
      },
    ],
    infoDocSection: {
      infoOrDoc: "Required",
      infoDocList: [
        {
          name: "Proof of address (e.g., council tax statement or utility bill)",
        },
        {
          name: "Photo ID (e.g., passport, driving license)",
        },
        {
          name: "Mobile phone (a phone that can scan a QR code and take a selfie)",
        },
      ],
    },
  },
  {
    title: "Declaration",
    identifier: "DECLARATION",
    description:
      "The final step before submitting your retirement application.  Please ensure that all information is correct before continuing.",
    isBegin: false,
    isComplete: false,
    isUpComing: true,
    isSubStepsOpen: false,
    timer: "3 MINS",
    sequence: 6,
    subSteps: [
      {
        name: "Confirm details",
        identifier: "CONFIRM_DETAILS",
        isSubBegin: true,
        isSubComplete: false,
        isSubUpComing: false,
        sequence: 61,
      },
      {
        name: "Declaration",
        identifier: "DECLARATION",
        isSubBegin: false,
        isSubComplete: false,
        isSubUpComing: true,
        sequence: 62,
      },
    ],
    infoDocSection: {
      infoOrDoc: "",
      infoDocList: [],
    },
  },
];
export const addOnStep = [
  {
    name: "Confirm choices",
    identifier: "CONFIRM_CHOICES",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 33,
  },
];
export const contributionStep = {
  name: "Your contributions",
  identifier: "RA_CONTRIBUTION",
  isSubBegin: false,
  isSubComplete: false,
  isSubUpComing: true,
  sequence: 34,
};

export const taxFreeAddonStep = [
  {
    name: "Tax-free cash",
    identifier: "TAX_FREE_CASH",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 33,
  },
  {
    name: "Confirm choices",
    identifier: "CONFIRM_CHOICES",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 34,
  },
];
export const taxFreeAddonStepForActiveUser = [
  {
    name: "Tax-free cash",
    identifier: "TAX_FREE_CASH",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 33,
  },
  {
    name: "Invest the rest",
    identifier: "INVEST_THE_REST",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 34,
  },
  {
    name: "Confirm choices",
    identifier: "CONFIRM_CHOICES",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 35,
  },
  {
    name: "Your contributions",
    identifier: "RA_CONTRIBUTION",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 36,
  },
];
export const moneyinchunksAddonStep = [
  {
    name: "Money in chunks",
    identifier: "MONEY_IN_CHUNKS",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 33,
  },
  {
    name: "Confirm choices",
    identifier: "CONFIRM_CHOICES",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 34,
  },
];
export const guaranteedAnnuityAddonStep = [
  {
    name: "Cash lump sum",
    identifier: "RA_ANNUITY_CHOICE",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 33,
  },
  {
    name: "Annuity",
    identifier: "RA_ANNUITY_PROVIDER",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 34,
  },
  {
    name: "Confirm choices",
    identifier: "CONFIRM_CHOICES",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 35,
  },
];
export const regularIncomeAddonStep = [
  {
    name: "Cash lump sum",
    identifier: "RA_RI_CASH_LUMPSUM",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 33,
  },
  {
    name: "Regular income",
    identifier: "RA_RI_INVEST_THE_REST",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 34,
  },

  {
    name: "Confirm choices",
    identifier: "CONFIRM_CHOICES",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 35,
  },
  {
    name: "Illustrations",
    identifier: "ILLUSTRATIONS",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 36,
  },
];
export const regularIncomeAddonStepForActiveUsers = [
  {
    name: "Cash lump sum",
    identifier: "RA_RI_CASH_LUMPSUM",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 33,
  },
  {
    name: "Regular income",
    identifier: "RA_RI_INVEST_THE_REST",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 34,
  },

  {
    name: "Confirm choices",
    identifier: "CONFIRM_CHOICES",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 35,
  },
  {
    name: "Your contributions",
    identifier: "RA_CONTRIBUTION",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 36,
  },
  {
    name: "Illustrations",
    identifier: "ILLUSTRATIONS",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 37,
  },
];
export const mixMatchAddonStep = [
  {
    name: "Cash lump sum",
    identifier: "RA_MM_CASH_LUMPSUM",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 33,
  },
  {
    name: "Blend strategies",
    identifier: "RA_BEND_STRATEGIES",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 34,
  },
  {
    name: "Confirm choices",
    identifier: "CONFIRM_CHOICES",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 35,
  },
  {
    name: "Illustrations",
    identifier: "ILLUSTRATIONS",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 36,
  },
];
export const mixMatchAddonStepForActiveUsers = [
  {
    name: "Cash lump sum",
    identifier: "RA_MM_CASH_LUMPSUM",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 33,
  },
  {
    name: "Blend strategies",
    identifier: "RA_BEND_STRATEGIES",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 34,
  },

  {
    name: "Confirm choices",
    identifier: "CONFIRM_CHOICES",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 35,
  },
  {
    name: "Your contributions",
    identifier: "RA_CONTRIBUTION",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 36,
  },
  {
    name: "Illustrations",
    identifier: "ILLUSTRATIONS",
    isSubBegin: false,
    isSubComplete: false,
    isSubUpComing: true,
    sequence: 37,
  },
];

export const SETTINGS = {
  home: "home",
  investmentData: "investmentData",
  statePensionAgeTable: "statePensionAgeTable",
  retirementLivingStandard: "retirementLivingStandard",
  payoutRates: "payoutRates",
  retirementGuidanceComparison: "retirementGuidanceComparison",
  goals: "goals",
  iWantToMenu: "iWantToMenu",
  broadcastNotification: "broadcastNotification",
  contributions: "contributions",
  guidance: "guidance",
  learn: "learn",
  fAQ: "fAQ",
  jargonBuster: "jargonBuster",
  taxSavings: "taxSavings",
  guidanceAdvice: "guidanceAdvice",
  risksWarnings: "risksWarnings",
  financialCorrection: "financialCorrection",
  aboutUs: "aboutUs",
  usefulLinks: "usefulLinks",
  aboutTpt: "about-tpt",
  helpGuides: "helpGuides",
  schemeDocuments: "schemeDocuments",
  planYourFuture: "planYourFuture",
  termsConditions: "termsConditions",
  privacyPolicy: "privacyPolicy",
  cookiePolicy: "cookiePolicy",
  contactUs: "contactUs",
  accessibility: "accessibility",
  feedbackForm: "feedbackForm",
  timeTravel: "timeTravel",
  planYourFutureAssumptions: "planYourFutureAssumptions",
  timeTravelAssumptions: "timeTravelAssumptions",
  support: "support",
  changeInvestment: "changeInvestment",
};

export const potCharges = {
  SavingsAndDrawdown: "Savings and drawdown",
  Drawdown: "Drawdown",
  ManagedForYou: "Managed for you",
  SelfManaged: "Self-managed",
};

export const countries = [
  "GB",
  "AS",
  "AI",
  "AG",
  "AU",
  "BS",
  "BJ",
  "BT",
  "IN",
  "JE",
  "US",
];

export const customLabels = {
  AD: { primary: "Andorra", secondary: "+376" },
  AE: { primary: "United Arab Emirates", secondary: "+971" },
  AF: { primary: "Afghanistan", secondary: "+93" },
  AG: { primary: "Antigua and Barbuda", secondary: "+1268" },
  AI: { primary: "Anguilla", secondary: "+1264" },
  AL: { primary: "Albania", secondary: "+355" },
  US: { primary: "United States", secondary: "+1" },
  GB: { primary: "United Kingdom", secondary: "+44" },
  AS: { primary: "American Samoa", secondary: "+1684" },
  IN: { primary: "India", secondary: "+91" },
  JE: { primary: "Jersy", secondary: "+44" },
  AU: { primary: "Australia", secondary: "+61" },
  BS: { primary: "Bahamas", secondary: "+1242" },
  BJ: { primary: "Benin", secondary: "+229" },
  BT: { primary: "Bhutan", secondary: "+975" },
};
